export default __webpack_public_path__ + "static/media/central-bank-of-trinidad-and-tobago-seeklogo.8ce0cc46.svg";